export default "__VITE_ASSET__69871804__$_?nuxt_component=async__"